(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category-product-toggle"] && !Shopify.designMode) return;
  try {
    
class CategoryProductToggle extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-category-tab]');
    this.contents = this.querySelectorAll('[data-category-content]');

    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const targetId = clickedTab.dataset.categoryTab;

    // Update tabs
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-selected', 'false');
    });
    clickedTab.setAttribute('aria-selected', 'true');

    // Update content
    this.contents.forEach(content => {
      if (content.dataset.categoryContent === targetId) {
        content.hidden = false;
      } else {
        content.hidden = true;
      }
    });
  }
}

customElements.define('category-product-toggle', CategoryProductToggle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
